export default {"src":"/_next/static/media/line-02.c125f965.svg","height":45,"width":124,"blurWidth":0,"blurHeight":0};